import updateReport from '../../../actions/api/report/updateReport';

/**
 * チェックボックスで選択している報告書を更新する関数
 *
 * @param {string} apiToken - APIトークン
 * @param {string} targetGroupId - 選択中のグループのID
 * @param {Array} reports - 報告書情報の配列
 * @param {number[]} reportIds - 更新する報告書のIDの配列
 * @param {Function} dispatch - redux dispatch関数
 */
const updateReports = (
  apiToken,
  targetGroupId,
  reports,
  selectedReportId,
  dispatch,
) => {
  const apiParams = {
    isEnabled: false,
  };

  const selectedReports = reports.filter(report =>
    selectedReportId.includes(report.id),
  );

  selectedReports.forEach(report => {
    dispatch(
      updateReport(
        apiToken,
        apiParams,
        targetGroupId,
        report.id,
        report.updatedAt,
      ),
    );
  });
};

export default updateReports;
